export const environment = {
	production: true,
	baseUrl: 'https://api.vehicle.ford.com/svl/',
	environment: 'PROD',
	oauth: {
		url: 'https://corp.sts.ford.com/adfs/oauth2/authorize',
		client_id: 'urn:fleetportal:clientid:web_fleetportal:prod',
		resource_id: 'urn:fleetportal:resource:web_fleetportal:prod',
		response_type: 'token',

		strAccessToken: 'KAPLAPCEJP',
		encodedAccessToken: 'WTHILTIG',
		tokenIssue: 'YFTTSLHERU',
		tokenExp: 'YRIRAT',
		userId: 'PIEIEKNPI',
		block_redirect: 'NAIBHRDOAWS',
		permissions: 'ECILEAST',
		logged_history: 'UALN'
	}
};
